// Import PrismJS theme for syntax highlighting
require("prismjs/themes/prism-tomorrow.css")

// Unregister old service worker to fix blank screen issue
export const onClientEntry = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            for (let registration of registrations) {
                registration.unregister()
            }
        })
    }
}
